import { render, staticRenderFns } from "./ChangeItem.vue?vue&type=template&id=c546ea86"
import script from "./ChangeItem.vue?vue&type=script&lang=ts"
export * from "./ChangeItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c546ea86')) {
      api.createRecord('c546ea86', component.options)
    } else {
      api.reload('c546ea86', component.options)
    }
    module.hot.accept("./ChangeItem.vue?vue&type=template&id=c546ea86", function () {
      api.rerender('c546ea86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/comparison/ChangeItem.vue"
export default component.exports